export function includeFieldsToRelatedFieldSuffix(includeFields: string[] | undefined): string {
    return (includeFields?.slice() ?? []).sort().join(',')
}
